import React, {useCallback, useContext, useState} from "react";
import {WizardContext} from "../Wizard";
import {WizardFormDeliveryInput} from "./WizardFormDeliveryInput";
import {WizardFormInput} from "./WizardFormInput";
import {wizardFormDelivery, wizardFormDirectYN, wizardFormQuantity, wizardFormY} from "../../../../../util/Constants";
import {
    CHANGE_OPTION_INPUT_DATA,
    CHANGE_OPTION_QUANTITY_DATA,
    SET_MIN_AND_MAX_PRICE,
    SET_SELECT_CHECKBOX
} from "../../WizardConstants";
import {WizardFormQuantityInput} from "./WizardFormQuantity";

export function WizardFormCheckBox({ data }) {
    const { dispatch } = useContext(WizardContext);
    const [selectInput, setSelectInput] = useState(false);
    const onChange = useCallback(
        (e) => {
            const checked = e.target.checked;
            if(checked) {
                dispatch({ type: SET_SELECT_CHECKBOX, name: data.name, selected: !selectInput, price_min: data.price_min, price_max: data.price_max })
            }else {
                dispatch({ type: SET_SELECT_CHECKBOX, name: data.name, selected: !selectInput, price_min: 0, price_max: 0 })
                dispatch({ type: CHANGE_OPTION_QUANTITY_DATA, dataName: data.name, optionValue: '' })
                dispatch({ type: CHANGE_OPTION_INPUT_DATA, dataName: data.name, optionValue: '' })
            }
            dispatch({ type: SET_MIN_AND_MAX_PRICE })
            setSelectInput(!selectInput)
        },
        [selectInput, data, dispatch],
    );
    return (
        <div className="form-group border p-2">
            <div className="checkbox-inline">
                <label className="checkbox m-0 ">
                    <input type="checkbox" onChange={onChange} value={selectInput} name={data.name}/>
                    <span></span>
                    <strong>{`${data.name} : `}</strong>
                </label>

            </div>
            <pre style={{whiteSpace: "pre-wrap",fontSize: "larger"}}>{`${data.description === undefined ? '' : data.description}`}</pre>

            {
                (data[wizardFormDirectYN] === wizardFormY && selectInput) &&
                (data.name === wizardFormDelivery ?
                    <WizardFormDeliveryInput data={data} />
                    :
                    data.name === wizardFormQuantity ?
                        <WizardFormQuantityInput data={data}/>
                        :
                        <WizardFormInput data={data} />
                )
            }
        </div>

    )
}